
// Helper functions to convert stripe count string to integer for database storage and vice versa

export const parseStripeCount = (stripeCount: string | number | undefined): number => {
  if (typeof stripeCount === 'number') {
    return stripeCount;
  }
  if (typeof stripeCount === 'string') {
    // Handle the corrected formats: "no stripes" -> 0, "1" -> 1, "2" -> 2, etc.
    if (stripeCount === 'no stripes' || stripeCount === '0') {
      return 0;
    }
    // Handle numeric strings like "1", "2", "3", "4"
    const parsed = parseInt(stripeCount, 10);
    return isNaN(parsed) ? 0 : parsed;
  }
  return 0; // Default to 0 stripes
};

export const formatStripeCount = (stripeCount: number): string => {
  if (stripeCount === 0) {
    return 'no stripes';
  }
  return stripeCount.toString(); // Return "1", "2", "3", "4"
};
